
export const regions = {
//   usa: { data: usa, type: 'json' },
//   uk: { data: uk, type: 'json' },

//   alabama: { data: alabama, type: 'json' },

    alaska: { type: 'api' },
    alabama: { type: 'api' },
    arkansaa: { type: 'api' },
    arizona: { type: 'api' },
    california: { type: 'api' },
    connecticut: { type: 'api' },
    colorado: { type: 'api' },
    delaware: { type: 'api' },
    florida: { type: 'api' },
    georgia: { type: 'api' },
    hawaii: { type: 'api' },
    idaho: { type: 'api' },
    iowa: { type: 'api' },
    indiana: { type: 'api' },
    illinois: { type: 'api' },

    texas: { type: 'api' },
    nebraska: { type: 'api' },
    massachusetts: { type: 'api' },
    wisconsin: { type: 'api' },
    district_of_columbia: { type: 'api' },
    wyoming: { type: 'api' },
    kansas: { type: 'api' },
    missouri: { type: 'api' },
    maine: { type: 'api' },
    guam: { type: 'api' },
    west_virginia: { type: 'api' },
    new_jersey: { type: 'api' },
    virginia: { type: 'api' },
    maryland: { type: 'api' },
    pennsylvania: { type: 'api' },
    rhode_island: { type: 'api' },
    washington: { type: 'api' },
    new_hamsphire: { type: 'api' },
    michigan: { type: 'api' },
    kentucky: { type: 'api' },
    new_mexico: { type: 'api' },
    oklahoma: { type: 'api' },
    south_dakota: { type: 'api' },
    vermont: { type: 'api' },
    utah: { type: 'api' },
    virgin_islands: { type: 'api' },
    north_dakota: { type: 'api' },
    minnesota: { type: 'api' },
    montana: { type: 'api' },
    tennessee: { type: 'api' },
    american_samoa: { type: 'api' },
    nevada: { type: 'api' },
    south_carolina: { type: 'api' },
    mississippi: { type: 'api' },
    puerto_rico: { type: 'api' },
    new_york: { type: 'api' },
    oregon: { type: 'api' },
    louisiana: { type: 'api' },
    ohio: { type: 'api' },
    north_carolina: { type: 'api' },
};

export const specialAreas = {
  usa: {
    Alaska: {
      left: -131,
      top: 25,
      width: 15
    },
    Hawaii: {
      left: -110,
      top: 28,
      width: 5
    },
    'Puerto Rico': {
      left: -76,
      top: 26,
      width: 2
    }
  }
};

export const regionOptions = Object.keys(regions).map(key => {
    const label = key.replace('_', ' ');
    if (key === 'uk' || key === 'usa') {
        return [key, label.toUpperCase()];
    }
    return [key, label[0].toUpperCase() + label.slice(1)];
});

export default regions;
